<script setup>
import { inject } from 'vue'
import { Button } from '@contentstudio/ui'
import { useAIPostGeneration } from '@modules/publisher/ai-content-library/composables/useAIPostGeneration'
import { useSetup } from '@modules/publisher/ai-content-library/composables/useSetup'

const root = inject('root')
const { $cstuModal } = root

const { AIUserProfile } = useSetup()
const {
  postGenerationLoader,
  remainingFreeTries,
} = useAIPostGeneration(AIUserProfile)


// Function to handle post generation with custom prompt
const handleGenerate = async () => {

  $cstuModal.show('custom-generate-modal')

// // if no post generation settings are available, show post settings modal
// if (!hasPostGenerationSettings.value) {
//   $cstuModal.show('custom-generate-modal')
//   return
// }

//     // If custom prompt is provided, use the custom API
//     const apiData = {
//       custom_prompt: '',
//       post_generation_settings: {
//         // Get values from AIUserProfile's post_generation_settings
//         style: AIUserProfile.value?.post_generation_settings?.style,
//         brand_voice: AIUserProfile.value?.post_generation_settings?.brand_voice,
//         social_platform: AIUserProfile.value?.post_generation_settings?.social_platform,
//         language: AIUserProfile.value?.post_generation_settings?.language,
//         theme: 'idsaved',
//         post_type: AIUserProfile.value?.post_generation_settings?.post_type || 'image',
//         no_of_posts: AIUserProfile.value?.post_generation_settings?.no_of_posts || 10,
//         caption_length: AIUserProfile.value?.post_generation_settings?.caption_length || {
//           min: 1,
//           max: 10
//         },
//         emoji_usage: AIUserProfile.value?.post_generation_settings?.emoji_usage || 'mid',
//         hashtag_usage: AIUserProfile.value?.post_generation_settings?.hashtag_usage || 'mid'
//       }
//     }

//     await generateCustomPosts(apiData)

}

</script>

<template>
  <div class="w-[554px] h-auto rounded-xl shadow-lg bg-graffiti p-6">
      <div class="flex flex-col justify-center items-center gap-y-4">
        <img
          alt="white label successful icon"
          src="@assets/img/settings/white-label/success.svg"
          class="w-16 h-16 mt-4"
        />
        <h2 class="text-2xl font-semibold text-center text-[#3A4557] my-2"
          >🎉 Brand profile created successfully!</h2>

          <p class="text-center text-lg text-[#757575] my-2">
            Let AI generate posts that truly reflect your brand.
            <br>
            <template v-if="remainingFreeTries > 0">
            Enjoy <strong>{{ remainingFreeTries }}</strong> free content generation {{remainingFreeTries === 1 ? 'try' : 'tries'}}
            <br>
           <small> Your plan credits won’t be used.</small>
           </template>
          </p>

          <Button
            :loading="postGenerationLoader"
            :disabled="postGenerationLoader"
            size="md"
            class="mt-4"
            @click="handleGenerate"
          >
            <img
              src="@src/modules/publisher/assets/ai-icon.svg"
              class="h-4 w-4"
              alt=""
            />
            Generate Content
          </Button>
      </div>
  </div>
</template>

<style scoped>

/* Add bg image   */
.bg-graffiti {
  background-color: #fff;
  background-image: url('~@assets/img/grafitti-bg.svg');
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
